import { useContext, useState, useEffect } from 'react';
import './pane-right-messages-header.scss';
import { CheckBox } from 'devextreme-react/check-box';
import { TextBox } from 'devextreme-react/text-box';

const MessagesHeader = ({ handleSearch }) => {
    const [timeoutId, setTimeoutId] = useState(null);
    
    const handleTextBoxOnValueChanged = (e) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        const newTimeoutId = setTimeout(() => {
            handleSearch(e.value);    
        }, 1000); 

        setTimeoutId(newTimeoutId);
    };

    return (

        <div className="messages-header">
            <TextBox className="messages-header-search" 
                placeholder="Шукати..."
                mode="search"
                valueChangeEvent="keyup"
                onValueChanged={handleTextBoxOnValueChanged}
            />
        </div>

    );
};

export default MessagesHeader;



